/**
 * TanStack Query hooks for `custom-fx-rate-per-invoice`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customFxRatePerInvoiceQueryKeys,
	type CreateCustomFxRatePerInvoiceBody,
	type ListCustomFxRatePerInvoiceResponse,
	type CustomFxRatePerInvoiceRow,
} from "./api";

export function useCustomFxRatePerInvoiceList(): UseQueryResult<ListCustomFxRatePerInvoiceResponse, Error> {
	return useQuery({
		queryKey: customFxRatePerInvoiceQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomFxRatePerInvoiceCreate(): UseMutationResult<CustomFxRatePerInvoiceRow, Error, CreateCustomFxRatePerInvoiceBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customFxRatePerInvoiceQueryKeys.all });
		},
	});
}

export function useCustomFxRatePerInvoiceDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customFxRatePerInvoiceQueryKeys.all });
		},
	});
}
